(function () {
  function init() {
    var emailInput = document.getElementById('ContactForm-email');
    if (!emailInput) return;

    var errorMessage = document.getElementById('ContactForm-email-error');
    var errorBanner = document.querySelector('#ContactForm > div.form__message');
    var errorList = document.querySelector('#ContactForm > ul.form-status-list');

    if (!errorMessage && !errorBanner && !errorList) return;

    function clearStaleError() {
      if (!emailInput.checkValidity() || emailInput.value.trim() === '') return;

      emailInput.removeAttribute('aria-invalid');
      emailInput.removeAttribute('aria-describedby');

      if (errorMessage) errorMessage.remove();
      if (errorBanner) errorBanner.remove();
      if (errorList) errorList.remove();

      emailInput.removeEventListener('input', clearStaleError);
      emailInput.removeEventListener('change', clearStaleError);
    }

    clearStaleError();
    emailInput.addEventListener('input', clearStaleError);
    emailInput.addEventListener('change', clearStaleError);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
